import React, { useEffect, useState } from 'react'

import { AddFilled } from '@carbon/icons-react'
import Chip from '../../../components/New/Chip/Chip'
import { DDSTypography } from 'den-design-system'
import DropdownMenu from '../../../components/New/DropdownMenu/DropdownMenu'
import Search from '../../../components/New/Search/Search'
import ToastNotification from '../../../components/common/DDS/Toast/Toast'
import UserAvatar from '../../../components/common/UserAvatar/UserAvatar'
import emptyAvatar from '../../../assets/icons/emptyAvatar.svg'
import pallete from '../../../global/newPallete'

interface PriorityDropDownProps {
  id?: string
  label?: string
  editable?: boolean
  disabled?: boolean
  userOptions?: any[]
  menuPosition?: string
  arrowPosition?: 'left' | 'right' | 'center'
  selectedUsers?: any
  setSelectedUsers?: any
  tableHeight?: any
  left?: boolean
  disableNoSubscription?: any
}

const toTitleCase = (str: string) => {
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
const IncidentMenuList: React.FC<PriorityDropDownProps> = ({
  id,
  editable = true,
  userOptions = [],
  selectedUsers = [],
  disabled = false,
  disableNoSubscription = false,
  setSelectedUsers,
  tableHeight,
  menuPosition = 'right',
  arrowPosition = 'center',
  left
}) => {
  const [menuOpen, setMenuOpen] = useState(false)
  const [allUsers, setAllUsers] = useState<any>([])
  const [showError, setShowError] = useState(false)

  useEffect(() => {
    setAllUsers(userOptions)
  }, [userOptions])

  // Function to get user initials
  const getUserInitials = (firstName: string, lastName: string) => {
    const firstInitial = firstName?.charAt(0)?.toUpperCase() || ''
    const lastInitial = lastName?.charAt(0)?.toUpperCase() || ''
    return `${firstInitial}${lastInitial}`
  }

  const [menuPositionList, setMenuPositionList] = useState<'above' | 'below'>(
    'below'
  )

  React.useEffect(() => {
    if (dropDownRef.current) {
      const dropdownRect = dropDownRef.current.getBoundingClientRect()
      const windowHeight = window.innerHeight
      if (dropdownRect.bottom + 250 > windowHeight) {
        setMenuPositionList('above')
      } else {
        setMenuPositionList('below')
      }
    }
  }, [tableHeight])

  const getMenuPosition = () => {
    if (menuPosition === 'left') {
      return '-translate-x-[85%]'
    } else if (menuPosition === 'center') {
      return '-translate-x-[40%]'
    } else if (menuPosition === 'right') {
      return ''
    }
  }

  const avatarObjects: { name: string; avatar: string }[] = []
  if (selectedUsers && selectedUsers.length > 0) {
    selectedUsers.forEach((assignedMember: any) => {
      const avatarObject = {
        name: assignedMember.name,
        avatar: assignedMember.imgUrl
      }
      avatarObjects.push(avatarObject)
    })
  }

  const [finalError, setFinalError] = useState(false)

  const removeSelectedUser = (itemId: string) => {
    if (selectedUsers.length === 1) {
      setShowError(true)
      setFinalError(false)

      ToastNotification({
        type: 'info',
        message:
          'Please add at least one user before removing the current user.'
      })

      setTimeout(() => {
        setShowError(false)
        setFinalError(true)
      }, 200)

      return
    }

    const selectedUsers_ = selectedUsers.filter(
      (user: any) => user.id !== itemId
    )
    setSelectedUsers([...selectedUsers_])
    setShowError(false)
    setFinalError(false)
  }

  const dropDownRef = React.useRef<HTMLDivElement>(null)
  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropDownRef.current &&
      !dropDownRef.current.contains(event.target as Node)
    ) {
      setMenuOpen(false)
    }
  }

  useEffect(() => {
    if (menuOpen) {
      document.addEventListener('click', handleClickOutside)
    } else {
      document.removeEventListener('click', handleClickOutside)
    }

    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [menuOpen])

  return (
    <div
      className={`${disabled && 'cursor-not-allowed opacity-50'} h-full w-full flex items-center justify-center`}
      ref={dropDownRef}
    >
      <div
        id={`menu-list-btn${id && '-' + id}`}
        className={`flex ${disabled && 'pointer-events-none opacity-50'} items-center ${selectedUsers.length === 0 ? 'gap-x-[4px]' : 'gap-x-[8px]'}  justify-start cursor-pointer`}
      >
        {selectedUsers.length === 0 && (
          <div>
            <img
              id={`menu-list-btn${id && '-' + id}`}
              src={emptyAvatar}
              onClick={() => setMenuOpen(!menuOpen)}
              className='h-[24px] flex  w-[24px]'
            />
          </div>
        )}
        <div>
          <UserAvatar
            id={`menu-list-btn${id && '-' + id}`}
            avatarType='Multiple'
            imageObjectGroup={selectedUsers.map((item: any, index: any) => {
              return {
                id: item?.user?.id,
                name: item?.user?.firstName + ' ' + item?.user?.lastName,
                firstName: item?.user?.firstName,
                lastName: item?.user?.lastName,
                avatar: item?.user?.avatar
              }
            })}
          />
        </div>

        <div>
          {editable && (
            <AddFilled
              id={`menu-list-btn${id && '-' + id}`}
              size={16}
              onClick={() => setMenuOpen(!menuOpen)}
              color={pallete.colors.textDark2}
            />
          )}
        </div>
      </div>

      <div
        className={` ${disableNoSubscription && 'cursor-not-allowed pointer-events-none'}  absolute z-50 `}
      >
        <DropdownMenu
          id='uc-menu-list'
          open={menuOpen}
          parentId='menu-list-btn'
          arrowPosition={arrowPosition}
          onClose={() => {
            setMenuOpen(false)
            setAllUsers([...userOptions])
            setFinalError(false)
          }}
          finalError={finalError}
          showError={showError}
          className={`${getMenuPosition} absolute z-[9999] mt-[5px] ${left ? 'left-[-286px]' : 'left-[-167px]'} top-[16px] !min-w-[112px] max-h-[380px] override-padding ${
            menuPositionList === 'above' ? 'translate-y-[-215px]' : ''
          }`}
          style={{
            transform: showError ? 'translateX(2px)' : 'translateX(0)',
            transition: showError ? 'transform 0.5s ease-in-out' : 'none'
          }}
        >
          <div className='flex flex-col gap-[8px] '>
            {selectedUsers?.length !== 0 && (
              <div className='flex flex-col max-h-[85px] gap-[6px]  overflow-y-scroll'>
                {selectedUsers?.map((item: any, index: any) => (
                  <Chip
                    id='chip-menu-list'
                    key={index}
                    label={item?.user?.firstName + ' ' + item?.user?.lastName}
                    onClose={() => removeSelectedUser(item.id)}
                  />
                ))}
              </div>
            )}
            <Search
              id='search'
              name='Search'
              placeholder='Search'
              onChange={(e) => {
                const filteredUsers = userOptions.filter((user: any) =>
                  user.name.toLowerCase().includes(e.target.value.toLowerCase())
                )
                setAllUsers([...filteredUsers])
              }}
            />
            <div className='flex flex-col gap-[8px] max-h-[168px] overflow-y-scroll'>
              {[...allUsers]
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((item) => (
                  <div
                    key={item.id}
                    className={`${
                      disableNoSubscription
                        ? 'cursor-not-allowed opacity-50'
                        : ''
                    } flex rounded-md menu-list-hover w-full cursor-pointer items-center gap-[8px] p-[8px]`}
                    onClick={() => {
                      const isAlreadySelected = selectedUsers.some(
                        (user: any) => item.id === user.id
                      )
                      if (!isAlreadySelected) {
                        setSelectedUsers([...selectedUsers, item])
                      }
                    }}
                  >
                    {item.imgUrl ? (
                      <img
                        src={item.imgUrl}
                        className='w-[20px] h-[20px] rounded-full object-cover'
                        alt={item.name}
                      />
                    ) : (
                      <div
                        className='rounded-full w-[24px] h-[24px] flex items-center justify-center'
                        style={{
                          border: `1px solid ${pallete.colors.stroke2}`
                        }}
                      >
                        <DDSTypography.Paragraph
                          size='caption'
                          variant='bold'
                          color={pallete.colors.textDark3}
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                          }}
                        >
                          {getUserInitials(item.firstName, item.lastName)}
                        </DDSTypography.Paragraph>
                      </div>
                    )}
                    <div className='flex justify-start gap-[8px] items-center'>
                      <DDSTypography.Paragraph
                        className='whitespace-nowrap'
                        variant='medium'
                        size='para'
                        color={pallete.colors.textDark4}
                      >
                        {item.name}
                      </DDSTypography.Paragraph>
                      <DDSTypography.Paragraph
                        variant='regular'
                        size='caption'
                        className='flex items-center'
                        color={pallete.colors.textDark9}
                      >
                        ({item.role})
                      </DDSTypography.Paragraph>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </DropdownMenu>
      </div>
    </div>
  )
}

export default IncidentMenuList
